import { Component, OnInit } from '@angular/core';
import { paths } from '@app/constants';
import { Router } from '@angular/router';
import { TouchService } from '@app/core/services/touch/touch.service';

@Component({
  selector: 'app-voucher-header',
  templateUrl: './voucher-header.component.html',
  styleUrls: ['./voucher-header.component.scss']
})
export class VoucherHeaderComponent implements OnInit {
  constructor(
    private router: Router,
    // this service is in-use by template, please do not remove
    public touchService: TouchService
  ) {}

  ngOnInit() {}

  onLogin(event) {
    event.preventDefault();

    this.router.navigate([paths.LIGHT_HOUSE_CHART, paths.REDEEM_VOUCHER], { replaceUrl: false });
  }
}
